import useAuthorization from './useAuthorization'

const usePlannerAuthorization = () => {
  const isUserAuthorized = useAuthorization()
  const isUserPlannerAuthorized = (permissionCode) => {
    return isUserAuthorized(permissionCode) || isUserAuthorized('AI_' + permissionCode)
  }
  return isUserPlannerAuthorized
}

export default usePlannerAuthorization
